import { Link } from "react-router-dom";
function MindPageLink(props) {
    function getDestination() {
        return window.location.hostname.includes("keelmind.com")
            ? props.href.replace("/mind", "")
            : props.href;
    }
    return <Link {...props} to={getDestination()} />;
}

export default MindPageLink;
